var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOsAppleBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:black;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "os-apple",
    className: "st0",
    d: "M12.6,4.4c0.7-0.7,1-1.7,0.9-2.7c-1,0.1-1.8,0.6-2.5,1.3s-1,1.7-0.9,2.7 C11,5.7,12,5.2,12.6,4.4z M14.6,10.5c0-1.3,0.7-2.5,1.8-3.1c-0.7-1-1.9-1.6-3.1-1.6c-1.3-0.1-2.7,0.8-3.2,0.8S8.3,5.8,7.3,5.8 c-2,0.1-4.2,1.7-4.2,5c0,1,0.2,2,0.5,3c0.5,1.4,2.2,4.7,3.9,4.6c0.9,0,1.6-0.6,2.8-0.6s1.8,0.7,2.8,0.7c1.8,0,3.3-3.1,3.7-4.4 C15.5,13.3,14.6,11.9,14.6,10.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsAppleBlack);
export default __webpack_public_path__ + "static/media/os-apple-black.1a7e8b0765646deb230e3ea5dc57c5d7.svg";
export { ForwardRef as ReactComponent };